import React, { useEffect, useState, useRef } from "react";
import "./control.css";
import data from "../../json/cicontrolitems";

const Control = () => {

  const [videoActivo, setVideoActivo] = useState(null);
  const videoRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // 🔴 Pausar video al cerrar modal
  const cerrarModal = () => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
    setVideoActivo(null);
  };

  return (
    <div
  className="container-full-width cinterno-bg"
  style={{
    backgroundImage: `url(${data.background})`,
    backgroundSize: "30%",        // Hace que la imagen cubra 30% del contenedor
    backgroundPosition: "center",   // Centra la imagen
    backgroundRepeat: "repeat",  // imagen en mosaico
    width: "100%",
    minHeight: "100vh"              // Ocupa toda la altura de la pantalla
  }}
>
      {/* ===== ENCABEZADO ===== */}
      <h3 className="title">
        Componentes de Control
      </h3>
      <hr className='hr-gob' />

      {/* ===== BARRA ===== */}
      <div className="subheader-links">
        {data.links?.map((link, index) => (
          <a key={index} href={link.url} className="link-custom">
            {link.texto}
          </a>
        ))}
      </div>

      {/* ===== SECCIÓN VIDEOS ===== */}
      <div className="video-section">

        {data.videos?.map((item) => (
          <div className="video-block" key={item.id}>

            {/* TÍTULO */}
            <h4 className="video-title">{item.titulo}</h4>

            {/* VIDEO */}
            <div className="video-container">
              <video controls>
                <source src={item.url} type="video/mp4" />
                Tu navegador no soporta video.
              </video>
            </div>

          </div>
        ))}

      </div>

      {/* ===== MODAL VIDEO ===== */}
      {videoActivo && (
        <div
          className="modal-overlay"
          onClick={cerrarModal}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >

            <div className="modal-header">
              <h3>{videoActivo.titulo}</h3>
              <button
                className="btn-cerrar"
                onClick={cerrarModal}
              >
                ✕
              </button>
            </div>

            <video ref={videoRef} controls autoPlay>
              <source src={videoActivo.url} type="video/mp4" />
            </video>

          </div>
        </div>
      )}

    </div>
  );
};

export default Control;